module.exports = __webpack_public_path__ + "static/img/safeDi.90bbc9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/safeDi.png
// module id = 4PTG
// module chunks = 2